<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Production Sheet Item</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="columns">
            <div class="column is-half">
              <label class="label">Backing Product*</label>
              <product-selector v-model="item.b_product_master_id"/>
            </div>

            <div class="column is-half">
              <label class="label">Facing Product*</label>
              <product-selector v-model="item.f_product_master_id"/>
            </div>
          </div>

          <div class="columns">
            <div class="column is-half">
              <label class="label">Backing Thickness (inches)*</label>
              <v-text-field 
                placeholder="Backing Thickness in inches"
                v-model="item.b_thick_in_str"/>
            </div>

            <div class="column is-half">
              <label class="label">Facing Thickness (inches)*</label>
              <v-text-field 
                placeholder="Facing Thickness in inches"
                v-model="item.f_thick_in_str"/>
            </div>
          </div>

          <div>
            <div class="label-and-button pb-2">
              <label class="label mb-0">Slab Finishing</label>
              <span 
                class="tag pointer" 
                @click="managingFinishes = true">
                <span class="icon is-small">
                  <i class="fas fa-plus"></i>
                </span>
                <span>Manage Finishes</span>
              </span>
            </div>
            <v-select
              v-if="processingMethods.length > 0" 
              :options="processingMethods"
              item-text="processing_name"
              item-value="id"
              v-model="item.finishing_step_id"
            />
            <span v-else class="has-text-grey-light">
              No finishing steps available
            </span>
          </div>

          <div class="columns is-multiline">
            <div class="column is-12 mt-5 subtitle is-5 mb-0 pb-0">
              Finished Slab Dimensions
            </div>
            <div class="column is-one-third">
              <label class="label">Length (inches)*</label>
              <v-text-field
                required
                placeholder="Finished Quantity"
                v-model="item.length_in_str">
              </v-text-field>
            </div>
            <div class="column is-one-third">
              <label class="label">Width (inches)*</label>
              <v-text-field
                required
                placeholder="Finished Quantity"
                v-model="item.width_in_str">
              </v-text-field>
            </div>
            <div class="column is-one-third">
              <label class="label">Thickness (inches)*</label>
              <v-text-field
                required
                placeholder="Finished Quantity"
                v-model="item.s_thick_in_str">
              </v-text-field>
            </div>
          </div>

          <div class="field">
            <label class="label">Finished Quantity*</label>
            <v-text-field
              required
              placeholder="Finished Quantity"
              v-model="item.finished_qty">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Location</label>
            <v-text-field
              placeholder="Location"
              v-model="item.location">
            </v-text-field>
          </div>

          <div class="field">
            <label class="label">Description</label>
            <v-text-field
              placeholder="Description"
              v-model="item.desc">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNew()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>

    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'

import ProductSelector from '@/components/inventory/ProductSelector'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    productionSheetId: {
      type: [String, Number]
    }
  },
  components: { 
    VForm,
    VTextField,
    VSelect,
    ProductSelector
  },
  data() {
    return {
      item: {
        production_sheet_id: null,
        b_product_master_id: null,
        f_product_master_id: null,
        finishing_step_id: null,
        length_in_str: null,
        width_in_str: null,
        s_thick_in_str: null,
        finished_qty: null,
        location: null,
        desc: null
      },
      valid: false
    }
  },
  computed: {
    ...mapState("processings", ["processingMethods"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("productionSheet", ["addItem"]),
    ...mapActions("processings", ["getProcessingMethods"]),
    initialize() {
      if (this.processingMethods.length == 0) {
        this.getProcessingMethods({ per_page: 100 });
      }
    },
    addNew() {
      this.item.production_sheet_id = this.productionSheetId;
      this.addItem(this.item).then(() => {
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>
